module.exports = __webpack_public_path__ + "img/icon.01bc3b80.png";